import { render, staticRenderFns } from "./ReviewItem.vue?vue&type=template&id=51b6f747&scoped=true"
import script from "./ReviewItem.vue?vue&type=script&lang=ts"
export * from "./ReviewItem.vue?vue&type=script&lang=ts"
import style0 from "./ReviewItem.vue?vue&type=style&index=0&id=51b6f747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b6f747",
  null
  
)

export default component.exports